import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { ScrollTop } from '@ciceksepeti/cs-scroll-top';
import '@ciceksepeti/cs-scroll-top/styles.css';
import LiveChatWidgetWrapper from '@components/live-chat-widget-wrapper';
import { useResponsive } from '@hooks/use-responsive';
import styles from './styles.module.scss';
var BottomWidgets = function () {
    var _a;
    var _b = useResponsive(), isMobileDevice = _b.isMobileDevice, isTabletDesktop = _b.isTabletDesktop, isTabletMobile = _b.isTabletMobile;
    var bottomWidgetsCn = classNames(styles.bottomWidgets, (_a = {},
        _a[styles.bottomWidgetsTablets] = isTabletDesktop,
        _a));
    return (_jsxs("div", { className: bottomWidgetsCn, children: [_jsx(ScrollTop, { visibilityOffsetTop: 100 }), (!isMobileDevice || isTabletMobile) && _jsx(LiveChatWidgetWrapper, {})] }));
};
export default BottomWidgets;
